<!-- GARAGE DETAILS HEADER (ONLY THIS PAGE) -->
<nav class="navbar navbar-expand-lg classic transparent navbar-light"  [class.navbar-white]="isNavbarWhite">
  <div class="container flex-lg-row flex-nowrap align-items-center nav-bar">
    <div
      class="navbar-collapse-wrapper d-flex flex-row flex-nowrap w-100 justify-content-between align-items-center padding" >
      <div class="logo-wth-txt d-flex align-items-center gap-3 nav-logo">
        <!-- <img
          src="assets/img/mobile_autoverse_logo.svg"
          alt="Autoverse Logo"
        />
        <h2 class="m-0">AUTOVERSE</h2> -->
        <img
                [src]="garageData?.primaryLogo"
                alt="Garage Logo"
                class="navbar-garage-logo"
        />
      </div>
      <div class="d-lg-none me-2 qck-bkng" *ngIf="showQuickBooking">
        <button *ngIf="!isModalOpen"
            class="btn btn-sm btn-outline-primary rounded-pill qck-bkng-btn"
            (click)="openRequestModal()">
            Quick Booking
        </button>
      </div>
      <!-- Hamburger menu (mobile only) -->
      <button
        class="navbar-toggler d-lg-none mat-hamburger-btn"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target=".offcanvas-nav"
        aria-label="Toggle navigation"
      >
        <mat-icon>menu</mat-icon>
      </button>

    </div>

    <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start">
      <div class="offcanvas-header d-lg-none">
        <h3 class="text-white fs-30 mb-0"> {{ garageData?.garageShortName }}</h3>
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="offcanvas"
        ></button>
      </div>

      <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
        <ul class="navbar-nav align-items-center-abt">

          <a class="nav-link" (click)="scrollTo('About-us')">About Us</a>
          <a class="nav-link" (click)="scrollTo('why-choose-us')">Why Us</a>
          <a class="nav-link" (click)="scrollTo('our-services')">Our Services</a>
          <a class="nav-link" (click)="goToInsuranceClaimDetails()">Insurance Claim</a>
          <a class="nav-link" (click)="scrollTo('contact-us')">Contact Us</a>
          <!-- <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
              Explore
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" (click)="scrollTo('why-choose-us')">
                  Why Us
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="scrollTo('contact-us')">
                  Contact Us
                </a>
              </li>
            </ul>
          </li> -->
           <li class="nav-item book" *ngIf="showRequestBtn">
              <button
                class="btn btn-lg btn-outline-white rounded-pill rqstbtn "
                (click)="openRequestModal()">
                Book an Appointment
              </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>

<!-- /header -->
 <div class="map-main-div" id="contact-us" #contactUsRef>
  <section class="wrapper bg-light angled upper-end" *ngIf="garageData">
    <div class="container">
      <div class="row mb-14 mb-md-16">
        <div class="col-xl-10 mx-auto">
          <div class="card">
            <div class="row gx-0">
              
              <!-- Map -->
              <div class="col-lg-6 align-self-stretch">
                <div class=" map-container map map-full rounded-top rounded-lg-start">
                  <div class="map map-full rounded-top rounded-lg-start inner-map">
                    
                    <google-map
                      width="100%"
                      [center]="center"
                      [zoom]="14" [options]="mapOptions" class="google-map">

                      <map-marker
                        #markerElem="mapMarker"
                        [position]="marker.position"
                        [title]="marker.title"
                        [options]="marker.options"
                        (mapClick)="openInfo(markerElem)">
                        
                        <map-info-window>
                          <div>
                            <div style="display:flex; justify-content: space-between; align-items: center;">
                              <h2 class="small-map-header">{{ marker.title }}</h2>
                              <a [href]="directionsLink" target="_blank">
                                <img src="./assets/img/direction_images-removebg-preview.png"
                                    style="width:30px;height:30px; margin-left:10px;">
                              </a>
                            </div>

                            <p class="small-map-p">{{ marker.address }}</p>

                            <div style="display:flex; align-items:center;">
                              <strong style="margin-right:5px;">{{ marker.googleRatings }}</strong>
                              <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                                <mat-icon *ngIf="star === 'full'" style="color: gold; margin-right: 2px;">star</mat-icon>
                                <mat-icon *ngIf="star === 'half'" style="color: gold; margin-right: 2px;">star_half</mat-icon>
                              </ng-container>
                              <span style="margin-left: 5px; color:#3f78e0;">
                                {{ marker.googleReviewNumbers }} reviews
                              </span>
                            </div>

                            <!-- <a [href]="largerMapLink" target="_blank" style="color:#3f78e0;">View larger map</a> -->
                          </div>
                        </map-info-window>
                      </map-marker>
                    </google-map>
                    
                  </div>
                </div>
              </div>

              <!-- Details -->
              <div class="col-lg-6">
                <div class="p-md-11 p-lg-14 padding-div">
                  
                  <!-- Address -->
                  <div class="d-flex flex-row mb-3">
                    <div>
                      <div class="icon text-primary fs-28 me-4 mt-n1"> 
                        <i class="uil uil-location-pin-alt" style="color:dodgerblue;"></i>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-1">Address</h5>
                      <address>{{ garageData.address }}</address>
                    </div>
                  </div>

                  <!-- Ratings -->
                  <div class="d-flex flex-row mb-3">
                    <div>
                      <img src="./assets/img/googleicon.png" alt="Google" style="width:28px; height:28px !important; margin-right:16px;">
                    </div>
                    <div>
                      <h5 class="mb-1">Ratings / Reviews</h5>
                      <div class="div_ratings">
                        <span>{{ garageData.googleRatings }}</span>
                        <div class="div_new_rating">
                          <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                            <mat-icon *ngIf="star === 'full'">star</mat-icon>
                            <mat-icon *ngIf="star === 'half'">star_half</mat-icon>
                          </ng-container>
                        </div>
                        
                      </div>
                      <p>from {{ garageData.googleReviewNumbers }} Google reviews</p>
                    </div>
                  </div>

                   <div class="d-flex flex-row mb-3">
                    <div>
                      <div class="icon text-primary fs-28 me-4 mt-n1"> 
                        <!-- <i></i> -->
                        <div style="font-size: 20px;">🕘</div>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-1">Working Hours</h5>
                      <div>Mon-Sat : {{ garageData?.workingHours }}</div>
                       Sunday : Closed
                    </div>
                  </div>
                  <!-- <div class="animate__animated animate__slideInUp animate__delay-3s">
                      <button  #bookBtn
                        class="btn btn-lg btn-outline-white rounded-pill requestBtn-new"
                        (click)="openRequestModal()">
                        Book an Appointment
                      </button>
                    </div> -->
                  <div class="button_div">
                    <button class="requestBtn" (click)="openRequestModal()">
                      Book an Appointment
                    </button>
                  </div>


                  <!-- ==========requesta-a-call-bac-pop-up======= -->
                  <!-- <div class="modal fade popup" id="requestCallBackModal" tabindex="-1" aria-labelledby="requestCallBackModalLabel" aria-hidden="true" style="    background: rgba(0, 0, 0, 0.8) !important;">
                      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 35%; top: 60px;">
                          <div class="modal-content" style="border-radius: 16px;">

                          <div class="d-flex justify-content-between align-items-center mb-3" style=" padding: 10px 20px; margin: 0 !important; background: linear-gradient(to right, #F7FBFF, #FFFFFF);     border-radius: 10px;">
                              <h3 class="fw-bold m-0" style="font-size: 20px; font-weight: 900 !important; color: #0B2636;">
                              <div class="call-icon-and-text">
                                  <img src="./assets/img/call-image.png">
                                  <div> Request a Call Back </div>
                                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              
                              </h3>
                              
                          </div>

                          <p class="text-muted mb-4" style=" font-size: 14px !important;color: #57738A !important; padding: 5px 20px; margin: 0 !important; font-weight: 400;">Leave your details and (optionally) pick a coupon.</p>

                          <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" style="padding: 10px 20px;">
                          <input type="text" formControlName="name" class="form-control mb-2 p-2" placeholder="Name*" required>
                          <div class="text-danger small"
                              *ngIf="callbackForm.get('name')?.touched &&
                                      callbackForm.get('name')?.hasError('required')">
                            Name is required
                          </div>
                          <input type="text" formControlName="mobile" class="form-control mb-2 p-2" placeholder="Mobile Number*" maxlength="10" required>
                          <div class="text-danger small"
                                *ngIf="callbackForm.get('mobile')?.touched">
                              <span *ngIf="callbackForm.get('mobile')?.hasError('required')">
                                Mobile number is required
                              </span>
                              <span *ngIf="callbackForm.get('mobile')?.hasError('pattern')">
                                Enter a valid 10-digit mobile number
                              </span>
                          </div>
                          <input type="text" formControlName="issue" class="form-control mb-2 p-2" placeholder="Describe Your Issue (Optional)">

                          <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
                              <div *ngFor="let c of coupons" 
                                  class="coupon-card-option"
                                  [class.active]="selectedCoupon?.couponId === c.couponId"
                                  (click)="applyCoupon(c)">
                              <h5 class="fw-bold mb-1">{{ c.couponCode }} - {{ c.discount }}%</h5>
                              <p class="small m-0 text-muted">{{ c.description }}</p>
                              </div>
                          </div>

                          <button type="submit" class="btn btn-primary w-100" style= "background:#144579;">Submit Details</button>
                          
                          </form>
                          </div>
                      </div>
                  </div> -->


                  <!-- Overlay -->
                  <div     class="popup-overlay"   [class.active]="isModalOpen"     (click)="closeModal()">  </div>
                  
                  <!-- <div class="popup-container" [class.active]="isModalOpen">
                    <div class="popup-content">

             
                      <div class="popup-header">
                        <h3 class="fw-bold m-0">
                          <div class="call-icon-and-text">
                            <img src="./assets/img/call-image.png">
                            <div> Request a Call Back </div>
                            <button type="button" class="btn-close" (click)="closeModal()"></button>
                          </div>
                        </h3>
                      </div>

                      <p class="text-muted mb-4">
                        Leave your details and (optionally) pick a coupon.
                      </p>

                      <form [formGroup]="callbackForm" (ngSubmit)="submitForm()">
                        <input type="text" formControlName="name" class="form-control mb-2 p-2" placeholder="Name*" required>
                        <div class="text-danger small"
                          *ngIf="callbackForm.get('name')?.touched && callbackForm.get('name')?.hasError('required')">
                          Name is required
                        </div>

                        <input type="text" formControlName="mobile" class="form-control mb-2 p-2" placeholder="Mobile Number*" maxlength="10" required>
                        <div class="text-danger small" *ngIf="callbackForm.get('mobile')?.touched">
                          <span *ngIf="callbackForm.get('mobile')?.hasError('required')">Mobile number is required</span>
                          <span *ngIf="callbackForm.get('mobile')?.hasError('pattern')">Enter a valid 10-digit mobile number</span>
                        </div>

                        <input type="text" formControlName="issue" class="form-control mb-2 p-2" placeholder="Describe Your Issue (Optional)">

                        <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
                          <div *ngFor="let c of coupons" 
                              class="coupon-card-option"
                              [class.active]="selectedCoupon?.couponId === c.couponId"
                              (click)="applyCoupon(c)">
                            <h5 class="fw-bold mb-1">{{ c.couponCode }} - {{ c.discount }}%</h5>
                            <p class="small m-0 text-muted">{{ c.description }}</p>
                          </div>
                        </div>

                        <button type="submit" class="btn btn-primary w-100" style="background:#144579;">Submit Details</button>
                      </form>
                    </div>
                  </div> -->

                 <div class="popup-container" [class.active]="isModalOpen">
                  <div class="popup-content">

                    <!-- Header -->
                    <div class="popup-header">
                      <h3 class="fw-bold m-0">
                        <div class="call-icon-and-text d-flex align-items-center gap-2">
                          <!-- Updated icon -->
                          <!-- <img src="./assets/img/appointment-icon.png" alt="appointment" /> -->
                          <mat-icon>bookmark_border</mat-icon>
                          <!-- Updated title -->
                          <div>Book an Appointment</div>

                          <button type="button" class="btn-close ms-auto" (click)="closeModal()"></button>
                        </div>
                      </h3>
                    </div>

                    <!-- Updated subheading -->
                    <p class="text-muted mb-4">
                      Quick and easy appointment booking.
                    </p>
                    <!-- Form -->
                   <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" class="callback-form">
                    <div class="form-scroll-area">
                      <!-- Name -->
                      <div class="form-floating mb-3">
                        <input type="text"
                              formControlName="name"
                              class="form-control"
                              id="custName"
                              placeholder="Name">
                        <label for="custName">Name *</label>
                      </div>
                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('name')?.invalid">
                        Name is required
                      </div>
                      <!-- Mobile -->
                      <div class="form-floating mb-3">
                        <input type="text"
                              formControlName="mobile"
                              class="form-control"
                              id="custMobile"
                              placeholder="Mobile Number"
                              maxlength="10">
                        <label for="custMobile">Mobile Number *</label>
                      </div>
                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('mobile')?.invalid">
                        <span *ngIf="callbackForm.get('mobile')?.errors?.['required']">
                          Mobile number is required
                        </span>
                        <span *ngIf="callbackForm.get('mobile')?.errors?.['pattern']">
                          Mobile number must be 10 digits
                        </span>
                      </div>

                      <!-- Registration Number -->
                       <div class="form-floating mb-3">
                        <input type="text" formControlName="registrationNumber" (input)="formatRegistrationNumber()" class="form-control" id="regNo" placeholder="KA 03 MX 5059">
                        <label for="regNo">Registration Number *</label>
                        </div>
                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('registrationNumber')?.invalid">
                        <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['required']">
                          Registration number is required
                        </span>
                        <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['pattern']">
                          Format must be like KA03AB1234
                        </span>
                      </div>

                      <!-- Issue Dropdown -->
                     <div class="form-floating mb-3 select-floating">
                      <select
                        formControlName="issue"
                        class="form-select"
                        id="issueSelect"
                        required
                      >
                        <option value="" disabled ></option>
                        <option *ngFor="let service of services" [ngValue]="service">
                          {{ service.label }}
                        </option>
                      </select>

                      <label for="issueSelect">Select the issue *</label>
                      <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
                    </div>



                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('issue')?.invalid">
                        Please select an issue
                      </div>
                    </div>
                    <!-- Submit Button -->
                    <div class="form-footer">
                      <button type="submit" class="btn btn-primary w-100" [disabled]="isSubmitting">
                        {{ isSubmitting ? 'Booking...' : 'Book an Appointment' }}
                      </button>
                    </div>
                  </form>
                  </div>
                </div>               
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<!-- <div class="hero-wrapper"  id="hero-section" #heroSectionRef >
<section class="wrapper" >
  <div class=" swiper-hero dots-over" data-margin="0" data-autoplay="true" data-autoplaytime="7000" data-nav="true" data-dots="true" data-items="1">
    <div>
      <div class="swiper hero-swiper"  #heroSwiper>

        <button class="swiper-button-prev"  [class.disabled]="isPrevDisabled">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <button class="swiper-button-next" [class.disabled]="isNextDisabled">
          <mat-icon>arrow_forward</mat-icon>
        </button>
        <div class="swiper-wrapper">
            <div class="swiper-slide bg-image slide-1">
            <div class="container h-100">
              <div class="row h-100">
                <div class="col-md-10 offset-md-1 col-lg-7 offset-lg-0 col-xl-6 col-xxl-5 text-center text-lg-start justify-content-center align-self-center align-items-start">
                  <h2 class="display-1 fs-56 mb-4 text-white animate__animated animate__slideInDown animate__delay-1s">Reliable car service you can trust.</h2>
                  <p class="lead fs-23 lh-sm mb-7 text-white animate__animated animate__slideInRight animate__delay-2s">We take care of your car like our own. Genuine spare parts, and clear pricing — every time.</p>
                    <div class="animate__animated animate__slideInUp animate__delay-3s">
                      <button  #bookBtn
                        class="btn btn-lg btn-outline-white rounded-pill requestBtn-new"
                        (click)="openRequestModal()">
                        Book an Appointment
                      </button>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide bg-image slide-2">
            <div class="container h-100">
              <div class="row h-100">
                <div class="col-md-11 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center justify-content-center align-self-center">
                  <h2 class="display-1 fs-56 mb-4 text-white animate__animated animate__slideInDown animate__delay-1s">Service your car, completely stress-free.</h2>
                  <p class="lead fs-23 lh-sm mb-7 text-white animate__animated animate__slideInRight animate__delay-2s">Book an appointment — we’ll handle the rest.</p>
                    <div class="animate__animated animate__slideInUp animate__delay-3s">
                      <button  #bookBtn
                        class="btn btn-lg btn-outline-white rounded-pill requestBtn-new"
                        (click)="openRequestModal()">
                        Book an Appointment
                      </button>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide bg-image slide-3">
            <div class="container h-100">
              <div class="row h-100">
                <div class="col-md-10 offset-md-1 col-lg-7 offset-lg-5 col-xl-6 offset-xl-6 col-xxl-5 offset-xxl-6 text-center text-lg-start justify-content-center align-self-center align-items-start">
                  <h2 class="display-1 fs-56 mb-4 text-white animate__animated animate__slideInDown animate__delay-1s">Experts for every car brand</h2>
                  <p class="lead fs-23 lh-sm mb-7 text-white animate__animated animate__slideInRight animate__delay-2s">From routine servicing to complex repairs, we know how to keep your car running smoothly.</p>
                  <div class="animate__animated animate__slideInUp animate__delay-3s">
                    <button  #bookBtn
                      class="btn btn-lg btn-outline-white rounded-pill requestBtn-new"
                      (click)="openRequestModal()">
                      Book an Appointment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-hero"></div>
      </div>
    </div>
  </div>
</section>
</div> -->

<!-- /section -->
<section class="wrapper bg-light" id="About-us" #aboutSectionRef>
  <div class="container py-1 pb-10">
    <div class="row gx-lg-8 gx-xl-12 gy-12 align-items-center mb-10 mb-md-13">
      <div class="col-lg-6 position-relative">
        <div class="btn btn-circle btn-primary pe-none position-absolute counter-wrapper flex-column d-none d-md-flex" style="top: 50%; left: 50%; transform: translate(-50%, -50%); width: 170px; height: 170px;">
          <h3 class="text-white mb-1 mt-n2"><span class="counter counter-lg">10+</span></h3>
          <p>Year Experience</p>
        </div>
        <div class="row gx-md-5 gy-5 align-items-center">
          <div class="col-md-6">
            <div class="row gx-md-5 gy-5">
              <div class="col-md-10 offset-md-2">
                <figure class="rounded"><img src="../../../assets/img/specificgaragewebpageimages/garage-introduction-1.png" srcset="../../../assets/img/specificgaragewebpageimages/garage-hero-1.png 2x" alt=""></figure>
              </div>
              <!--/column -->
              <div class="col-md-12">
                <figure class="rounded"><img src="../../../assets/img/specificgaragewebpageimages/garage-introduction-3.png" srcset="../../../assets/img/specificgaragewebpageimages/garage-hero-2.png 2x" alt=""></figure>
              </div>
              <!--/column -->
            </div>
            <!--/.row -->
          </div>
          <!--/column -->
          <div class="col-md-6">
            <figure class="rounded"><img src="../../../assets/img/specificgaragewebpageimages/garage-introduction-2.png" srcset="../../../assets/img/specificgaragewebpageimages/garage-hero-3.png 2x" alt=""></figure>
          </div>
          <!--/column -->
        </div>
        <!--/.row -->
      </div>
      <!--/column -->
      <div class="col-lg-6" id="why-choose-us">
        <h3 class="display-4 mb-5">We are your neighbourhood garage you can truly trust.</h3>
        <p class="mb-7">We are a multi-brand car service garage.For us, every car matters and every customer matters even more.Whether it’s regular servicing or a sudden repair, we explain everything clearly and do only what your car actually needs.</p>
        <div class="row gy-3">
          <div class="col-xl-6">
            <ul class="icon-list bullet-bg bullet-soft-primary mb-0">
              <li><span><i class="uil uil-check"></i></span><span>Trained and skilled, our team handles every car with care.</span></li>
              <li class="mt-3"><span><i class="uil uil-check"></i></span><span>We handle servicing for all major car brands, big or small.</span></li>
            </ul>
          </div>
          <!--/column -->
          <div class="col-xl-6">
            <ul class="icon-list bullet-bg bullet-soft-primary mb-0">
              <li><span><i class="uil uil-check"></i></span><span>Clean, organised workshop where your car is treated with care.</span></li>
              <li class="mt-3"><span><i class="uil uil-check"></i></span><span>We are always here with friendly, honest support.</span></li>
            </ul>
          </div>
          <!--/column -->
        </div>
        <!--/.row -->
      </div>
      <!--/column -->
    </div>
    <!--/.row -->
  </div>
  <!-- /.container -->
</section>
<!-- /section -->

<!-- /section -->
<section class="wrapper bg-light">
  <div class="container py-10 pt-0">
    <!-- <div class="row text-center">
      <div class="col-lg-10 mx-auto position-relative">
        <div class="position-relative">
          <div class="shape pale-pink rellax w-18 h-18" data-rellax-speed="1" style="top: 1rem; left: -4.2rem;">
            <img src="./assets/img/svg/hex.svg" class="svg-inject icon-svg w-100 h-100" alt="" />
          </div>
          <div class="shape pale-primary rellax w-18 h-18" data-rellax-speed="1" style="bottom: 2rem; right: -3.5rem;">
            <img src="./assets/img/svg/circle.svg" class="svg-inject icon-svg w-100 h-100" alt="" />
          </div>
          <video poster="./assets/img/photos/movie.jpg" class="player" playsinline controls preload="none">
            <source src="./assets/media/movie.mp4" type="video/mp4">
            <source src="./assets/media/movie.webm" type="video/webm">
          </video>
        </div>
      </div>
    </div> -->
    <!--/.row -->
    <div class="row text-center mt-0">
      <div class="col-lg-10 mx-auto">
        <h2 class="fs-16 text-uppercase text-muted mb-3">DON’T KNOW WHAT SERVICE YOUR CAR NEEDS?</h2>
        <h3 class="display-3 text-center px-xl-10 px-xxl-15 mb-10">We understand cars can be confusing. That's why we make everything simple and clear for you</h3>
        <div class="row gx-lg-8 gx-xl-12 process-wrapper arrow text-center">
          <div class="col-md-4"> <img src="../../../assets/img/garagewebmissingimagesicons/inspection-first-dont-know-the-service-removebg-preview.png" class=" icon-svg icon-svg-sm solid-duo text-purple-pink mb-0" style="width: 50%; height: auto;" alt="" />
            <div class="margin-remove-div">
              <h3 class="fs-22">1. Inspection First</h3>
              <p>We check your car and tell you exactly what is needed.No surprises.</p>
            </div>
          </div>
          <!--/column -->
          <div class="col-md-4"> <img src="../../../assets/img/garagewebmissingimagesicons/clear-explanation-dont-know-the-service-removebg-preview.png" class=" icon-svg icon-svg-sm solid-duo text-purple-pink mb-0" style="width: 50%; height: auto;"  alt="" />
            <div class="margin-remove-div">
              <h3 class="fs-22">2. Clear Explanation</h3>
              <p>We explain problems in simple language you can easily understand.</p>
            </div>
          </div>
          <!--/column -->
          <div class="col-md-4"> <img src="../../../assets/img/garagewebmissingimagesicons/your-approval-matters-dont-know-the-service-removebg-preview.png" class=" icon-svg icon-svg-sm solid-duo text-purple-pink mb-0" style="width: 50%; height: auto;"  alt="" />
            <div class="margin-remove-div">
              <h3 class="fs-22">3. Your Approval Matters</h3>
              <p>We start work only after you approve the estimate.Your choice,always.</p>
            </div>
          </div>
          <!--/column -->
        </div>
        <!--/.row -->
      </div>
      <!-- /column -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</section>
<!-- /section -->

<!-- Coupon Section -->
<!-- <div class="coupon-section" *ngIf="coupons && coupons.length > 0">
  <h2>💰 Exclusive Offers Just for You</h2>
  <div class="coupon-row">
    <div *ngFor="let coupon of coupons" class="coupon-card">
      <div class="coupon-title">{{ decodeEntities(coupon.title) }}</div>
      <h3 style="color:#144579">{{ coupon.discount }}% OFF</h3>
      <div class="coupon-subtitle">{{ decodeEntities(coupon.subTitle) }}</div>
      <div class="coupon-code">{{ coupon.couponCode }}</div>
      <button class="redeem-btn" (click)="openModal(coupon)">Redeem Now</button>
    </div>
  </div>
</div> -->

<!-- Modal -->
<!-- Coupon Modal -->
<!-- <div class="modal-coupon" *ngIf="selectedCoupon">
  <div class="modal-content-coupon">

    <span class="hot-deal-tag">{{ decodeEntities(selectedCoupon.tagDeal || '🔥 HOT DEAL') }}</span>

    <div class="modal-header-container">
      <div class="modal-header">🎉 Redeem Your Offer</div>
      <span class="close-btn" (click)="closeModal()">&times;</span>
      
    </div>
    <div class="underline"></div>

    <div class="pop-up-parent-div">
      <div class="modal-subtitle">{{ decodeEntities(selectedCoupon.subTitle) }}</div>
      <div class="valid-date-coupon-code">{{ selectedCoupon.couponCode }}</div>
      <div class="valid-date">Valid till: {{ selectedCoupon.validTill | date:'dd-MMM-yyyy' }}</div>
      <div class="description">{{ decodeEntities(selectedCoupon.description) }}</div>
    </div>

    <form [formGroup]="couponForm" (ngSubmit)="applyCouponForm()">
      <input type="text" formControlName="couponName" placeholder="Name*" required class="form-control mb-2 p-2">
        <input type="text" formControlName="couponMobile" placeholder="Mobile Number*" maxlength="10" required class="form-control mb-2 p-2">
        <textarea type="text" formControlName="couponIssue" placeholder="Describe Your Issue (Optional)" class="form-control mb-2 p-2"></textarea>
        
            <button type="button" class="submit-btn btn btn-primary w-100" (click)="applyCouponForm()">
          🚀 Confirm & Apply Coupon
        </button>
      <div class="modal-footer-features">
        <div class="feature-item">
          <span>🔒</span><span>Secure Booking</span>
        </div>
        <div class="feature-item">
          <span>💯</span><span>Money Back Guarantee</span>
        </div>
        <div class="feature-item">
          <span>⚡</span><span>Instant Confirmation</span>
        </div>
      </div>
    </form>

  </div>

</div> -->

<!-- Success Confirmation Modal -->
<div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="width: 30%;">
    <div class="modal-content text-center">
      <div class="modal-body">
        <p style="margin-bottom: 0;">{{ successMessage }}</p>
        <p style="color: green; font-size: 100px;"><i class="uil uil-check-circle"></i></p>
        <p class="lead mb-6">We will call you shortly</p>
        <button type="button" class="btn btn-secondary rounded-pill btn-login w-100 mb-2" (click)="closeSuccessModal()" style="background: #144579;">OK</button>
      </div>
    </div>
  </div>
</div>

<div>
  <section class="wrapper bg-light" id="our-services">
    <div class="container_wrapper md-16 describe-prblm">
      <div class="row text-center">
        <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h2 class="fs-16 text-uppercase text-muted mb-3">ALL CAR SERVICES</h2>
          <h3 class="display-4 mb-10 px-xl-10">We take care of inspection, repairs, and maintenance</h3>
        </div>
        <!-- /column -->
      </div>
      
      <div class="position-relative">
        <div class="shape rounded-circle bg-soft-blue rellax w-16 h-16" data-rellax-speed="1"
            style="bottom: -0.5rem; right: -2.2rem; z-index: 0;"></div>
        <div class="shape bg-dot yellow rellax w-16 h-17" data-rellax-speed="1"
            style="top: -0.5rem; left: -2.5rem; z-index: 0;"></div>

        <div class="row gx-md-5 gy-5 text-center">

          <!-- 🔁 Dynamic Category Cards -->
          <div class="col-md-6 col-xl-3" *ngFor="let category of categories">
            <div class="card shadow-lg h-100">
              <div class="card-body d-flex flex-column " style="align-items: center;">
                <div class="category-imgs" >
                  <!-- Category Image -->
                  <img [src]="category.CategoryImage"
                      class="custom-image1 mb-3"
                      [alt]="category.name" />
                </div>

                <!-- Category Name -->
                <h4 class="category-title">{{ category.name }}</h4>

                <!-- Category Points -->
                <p class="mb-2 mb2-pdng category-points" style="font-size: 14px;">
                  {{ category.points }}
                </p>

                <!-- Button -->
                <div class="more hover link-yellow click-button mt-auto"
                    (click)="goToEstimateList()">
                  Learn More
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </section>
</div>

<!-- Why Choose Our Transparent Pricing Section -->
<!-- <section class="transparent-pricing">
<div class="powered-by">🚗 Powered by Autoverse</div>

<h1 class="gradient-title">Get Instant, Transparent</h1>
<div class="Price-Estimates">Price Estimates</div>
<div class="underline-price-estimate"></div>

<div class="Upfront-costs">Upfront costs with parts + labour split. No hidden fees, no surprises — 
just crystal-clear pricing you can trust. Get your estimate in under 60 seconds.</div>

<a (click)="goToRegistrationDecode()" class="main-btn">
  🚀 Get Price Estimates →
</a>

<div class="feature-pills">
<span>
  <div class="tick">✓</div>
  <div>Parts + Labour Split</div>
</span>
<span>
  <div class="tick">🔒</div>
  <div>Price Lock Guarantee</div>
</span>
<span>
  <div class="tick">💎</div>
  <div>Zero Hidden Charges</div>
</span>
</div>
<h2>Why Choose Our Transparent Pricing?</h2>
<p>Here’s why you can trust us with your vehicle needs.</p>
<div class="features">
<div class="feature-card">
  <div class="image-backgroun-color">
  <img src="../../../assets/img/price-estimate-28-8-2025/IMAGE.png" alt="100% Genuine Parts">
  </div>
  <h3>100% Genuine Parts</h3>
  <div class="genuine-part-class">Every estimate is backed by Autoverse's reliable parts supply chain.</div>
</div>
<div class="feature-card">
  <div class="image-backgroun-color">
    <img src="../../../assets/img/price-estimate-28-8-2025/IMAGE (1).png" alt="Transparent Pricing">
  </div>
  <h3>Transparent Pricing</h3>
  <div class="genuine-part-class">See parts and labour costs separately, so you always know what you're paying for.</div>
</div>
<div class="feature-card">
  <div class="image-backgroun-color">
    <img src="../../../assets/img/price-estimate-28-8-2025/IMAGE (2).png" alt="Trusted Garages">
  </div>
  <h3>Trusted Garages</h3>
  <div class="genuine-part-class">Your garage is now powered by Autoverse — bringing trust and reliability to every estimate.</div>
</div>
</div>

<section class="get-started">
<h2>Ready to Get Started?</h2>
<p>Get your transparent, detailed estimate in under 60 seconds. 
  No sign-up required, no hidden fees.</p>

<a (click)="goToRegistrationDecode()" class="cta-button">
  🚀 Start Your Estimate Now <span>&rarr;</span>
</a>

<div class="extra-info">
  ⚡ Average completion time: 45 seconds &nbsp; | &nbsp; 🔒 100% secure &nbsp; | &nbsp; 💎 No obligations
</div>
</section>
</section>
<div>
  <section class="wrapper bg-light" id="why-choose-us">
    <div class="container py-14 py-md-16">
      <div class="row gx-lg-8 gy-8 align-items-center">
        <div class="col-lg-6 order-lg-2">
          <div class="row gx-md-5 gy-5">
            <div class="col-md-4 offset-md-2 align-self-end">
              <figure class="rounded height-img"><img src="../../../assets/img/specificgaragewebpageimages/Garage Why Choose Us 2.png" srcset="../../../assets/img/specificgaragewebpageimages/Garage Why Choose Us 2.png 2x" alt=""></figure>
            </div>
            <div class="col-md-6 align-self-end">
              <figure class="rounded"><img src="../../../assets/img/specificgaragewebpageimages/Garage Why Choose Us 1.png" srcset="../../../assets/img/specificgaragewebpageimages/Garage Why Choose Us 1.png 2x" alt=""></figure>
            </div>
            <div class="col-md-6 offset-md-1">
              <figure class="rounded"><img src="../../../assets/img/specificgaragewebpageimages/Garage Why Choose Us 3.png" srcset="../../../assets/img/specificgaragewebpageimages/Garage Why Choose Us 3.png 2x" alt=""></figure>
            </div>
            <div class="col-md-4 align-self-start">
              <figure class="rounded"><img src="../../../assets/img/garagewebmissingimagesicons/Vertical Image Why Choose Us.png" srcset="../../../assets/img/garagewebmissingimagesicons/Vertical Image Why Choose Us.png 2x" alt=""></figure>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <h2 class="display-4 mb-3">Why Choose Us?</h2>
          <p class="lead fs-lg mb-8 pe-xxl-2">Every visit is simple, transparent, and worry-free, because we know how important your car is to you.</p>
          <div class="row gx-xl-10 gy-6">
            <div class="col-md-6 col-lg-12 col-xl-6">
              <div class="d-flex flex-row">
                <div>
                  <div class="icon btn btn-circle btn-lg btn-soft-primary pe-none me-5"> <img src="../../../assets/img/why-choose-us-images/Genuine_Parts_-_Why_Us-removebg-preview.png" class="preview-img"></div>
                </div>
                <div>
                  <h4 class="mb-1">Genuine Parts</h4>
                  <p class="mb-0">We always use genuine and reliable spare parts.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 col-xl-6">
              <div class="d-flex flex-row">
                <div>
                  <div class="icon btn btn-circle btn-lg btn-soft-primary pe-none me-5"> <img src="../../../assets/img/why-choose-us-images/Clear_Explanation_-_Why_Us-removebg-preview.png" class="preview-img"> </div>
                </div>
                <div>
                  <h4 class="mb-1">Clear Explanation</h4>
                  <p class="mb-0">We explain the problem before starting work.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 col-xl-6">
              <div class="d-flex flex-row">
                <div>
                  <div class="icon btn btn-circle btn-lg btn-soft-primary pe-none me-5"> <img src="../../../assets/img/why-choose-us-images/Tranparent_Pricing_-_Why_Us-removebg-preview.png" class="preview-img"> </div>
                </div>
                <div>
                  <h4 class="mb-1">Transparent Pricing</h4>
                  <p class="mb-0">No hidden charges — get full transparency.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 col-xl-6">
              <div class="d-flex flex-row">
                <div>
                  <div class="icon btn btn-circle btn-lg btn-soft-primary pe-none me-5"> <img src="../../../assets/img/why-choose-us-images/Valued_Time_-_Why_Us-removebg-preview.png" class="preview-img"> </div>
                </div>
                <div>
                  <h4 class="mb-1">Valued Time</h4>
                  <p class="mb-0">Your time and your car are respected at every visit.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div> -->
<!-- /section -->

<!-- /section -->
<section class="wrapper bg-soft-primary">
  <div class="container py-14 pt-md-17 pb-md-21">
    <div class="row gx-lg-8 gx-xl-12 gy-10 gy-lg-0 mb-2 align-items-end">
      <div class="col-lg-4">
        <h2 class="fs-16 text-uppercase text-line text-primary mb-3">GARAGE FACTS</h2>
        <h3 class="display-4 mb-0 pe-xxl-15">We are proud of our works</h3>
      </div>
      <!-- /column -->
      <div class="col-lg-8 mt-lg-2">
        <div class="row align-items-center counter-wrapper gy-6 text-center">
          <div class="col-md-4">
            <div class="count-main" >
              <h3 class="counter counter-lg">5000</h3>
              <div class="count-mat-icon"><mat-icon class="mat">add</mat-icon></div>
            </div>
            <p class="car-serviced">Car has been Serviced</p>
          </div>
          <!--/column -->
          <div class="col-md-4">
            <div class="count-main" >
              <h3 class="counter counter-lg">10</h3>
              <div class="count-mat-icon"><mat-icon class="mat">add</mat-icon></div>
            </div>
            <p>Year Experience</p>
          </div>
          <!--/column -->
          <div class="col-md-4" id="customer-review">
            <div class="count-main" >
              <h3 class="counter counter-lg">80</h3>
              <div class="count-mat-icon" style="    font-size: 24px; width: auto;   height: auto; padding: 0px 5px;">%</div>
            </div>
            <p>Same Day Service</p>
          </div>
          <!--/column -->
        </div>
        <!--/.row -->
      </div>
      <!-- /column -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</section>
<!-- /section -->

<!-- /section -->
 <div>
  <section class="wrapper bg-light angled upper-end lower-start">
    <div class="container py-16 py-md-18 position-relative" style="padding-bottom: 0 !important;">
      <div class="position-relative mt-n18 mt-n23">
        <div class="shape rounded-circle bg-line primary rellax w-18 h-18" data-rellax-speed="1" style="top: -2rem; right: -2.7rem; z-index:0;"></div>
        <div class="shape rounded-circle bg-soft-primary rellax w-18 h-18" data-rellax-speed="1" style="bottom: -1rem; left: -3rem; z-index:0;"></div>
        <div class="card shadow-lg image-down">
          <div class="row gx-0">
            <div class="col-lg-6 image-wrapper bg-image bg-cover rounded-top rounded-lg-start"><img src="../../../assets/img/specificgaragewebpageimages/garage-customer-testimonial.png">
            </div>
            <!--/column -->
            <div class="col-lg-6">
              <div class="">
                <div class="swiper-container dots-closer mb-4" data-margin="30" data-dots="true">
                  <div class="swiper testimonial-swiper" style="height: fit-content;">
                    <div class="swiper-wrapper" style="height: auto;">
                      <div
                        class="swiper-slide garage-testimonial"
                        *ngFor="let review of garageData?.reviews"
                        style="height: fit-content !important;"
                      >
                        <blockquote class="icon icon-top fs-lg text-center">
                          <p class="garage-review">“{{ review.testimonial }}”</p>

                          <div class="blockquote-details justify-content-center text-center">
                            <div class="info ps-0">
                              <h5 class="mb-1">{{ review.name }}</h5>
                              <p class="mb-0">Car Owner</p>
                            </div>
                          </div>
                        </blockquote>
                      </div>
                    </div>
                    <button class="swiper-button-prev-new"><mat-icon>arrow_back</mat-icon></button>
                    <!-- /.swiper-wrapper -->
                  </div>
                  <div class="swiper-pagination swiper-pagination-testimonial" style="bottom: 0;"></div>
                  <button class="swiper-button-next-new"><mat-icon>arrow_forward</mat-icon></button>
                  <!-- /.swiper -->
                </div>
                <!-- /.swiper-container -->
              </div>
              <!--/div -->
            </div>
            <!--/column -->
          </div>
          <!--/.row -->
        </div>
        <!-- /.card -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.container -->
  </section>
</div>
  <!-- /section -->

<!-- Makes -->
<div>
  <section id="makes" class="wrapper bg-light">
    <div class="container" style="padding-top: 80px;">
      <div class="row gx-lg-8 gx-xl-12 gy-10 gy-lg-0">
        <div class="col-lg-4 mt-lg-2">
          <h2 class="fs-15 text-uppercase text-muted mb-3">Cars we work on</h2>
          <h3 class="display-4 mb-3 pe-xxl-5">We service the most popular car brands on Indian roads.</h3>
          <p class="lead fs-lg mb-0 pe-xxl-5">If your car brand is not listed, call us — we’ll be happy to help.</p>
        </div>
        <div class="col-lg-8 position-relative d-flex align-items-center">
          <!-- Swiper Container -->
          <div class="swiper makes-swiper-container">
          <div class="swiper-wrapper">

            <!-- PAGE 1 -->
            <div class="swiper-slide">
              <div class="makes-grid">
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/marutisuzuki.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/hyundai.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/toyota.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/tata.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/honda.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/ford.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/volkswagen.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/mahindra.png"></div>
              </div>
            </div>

            <!-- PAGE 2 -->
            <div class="swiper-slide">
              <div class="makes-grid">
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/renault.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/skoda.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/chevrolet.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/fiat.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/nissan.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/audi.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/mercedesbenz.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/kia.png"></div>
              </div>
            </div>

          </div>
            <button class="swiper-button-prev-makes">
              <mat-icon class="arw-bck">arrow_back</mat-icon>
            </button>
            <button class="swiper-button-next-makes">
              <mat-icon class="arw-bck">arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>


<!-- <section class="garage-header">
  <img src="../../../assets/img/photos/bg3.jpg" class="garage-bg" alt="Garage Background">
  <div class="garage-overlay">
    <a href="./index.html" class="top-left-logo">
      <img class="logo-dark" id="GARAGE_LOGO" src="" alt="Garage Logo" style="display: none;"/>
    </a>
    <div class="head_container text-center">
      <h1 class="display-1 mb-3 text-white">
        {{ garageData?.name }}
      </h1>
    </div>
  </div>
</section>  -->

<div class="map-main-div" id="contact-us">
  <section class="wrapper bg-light angled upper-end" *ngIf="garageData">
    <div class="container">
      <div class="row mb-14 mb-md-16">
        <div class="col-xl-10 mx-auto">
          <div class="card">
            <div class="row gx-0">
              
              <!-- Map -->
              <div class="col-lg-6 align-self-stretch">
                <div class=" map-container map map-full rounded-top rounded-lg-start">
                  <div class="map map-full rounded-top rounded-lg-start inner-map">
                    
                    <google-map
                      width="100%"
                      [center]="center"
                      [zoom]="14" [options]="mapOptions" class="google-map">

                      <map-marker
                        #markerElem="mapMarker"
                        [position]="marker.position"
                        [title]="marker.title"
                        [options]="marker.options"
                        (mapClick)="openInfo(markerElem)">
                        
                        <map-info-window>
                          <div>
                            <div style="display:flex; justify-content: space-between; align-items: center;">
                              <h2 class="small-map-header">{{ marker.title }}</h2>
                              <a [href]="directionsLink" target="_blank">
                                <img src="./assets/img/direction_images-removebg-preview.png"
                                    style="width:30px;height:30px; margin-left:10px;">
                              </a>
                            </div>

                            <p class="small-map-p">{{ marker.address }}</p>

                            <div style="display:flex; align-items:center;">
                              <strong style="margin-right:5px;">{{ marker.googleRatings }}</strong>
                              <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                                <mat-icon *ngIf="star === 'full'" style="color: gold; margin-right: 2px;">star</mat-icon>
                                <mat-icon *ngIf="star === 'half'" style="color: gold; margin-right: 2px;">star_half</mat-icon>
                              </ng-container>
                              <span style="margin-left: 5px; color:#3f78e0;">
                                {{ marker.googleReviewNumbers }} reviews
                              </span>
                            </div>

                            <!-- <a [href]="largerMapLink" target="_blank" style="color:#3f78e0;">View larger map</a> -->
                          </div>
                        </map-info-window>
                      </map-marker>
                    </google-map>
                    
                  </div>
                </div>
              </div>

              <!-- Details -->
              <div class="col-lg-6">
                <div class="p-md-11 p-lg-14 padding-div">
                  
                  <!-- Address -->
                  <div class="d-flex flex-row mb-3">
                    <div>
                      <div class="icon text-primary fs-28 me-4 mt-n1"> 
                        <i class="uil uil-location-pin-alt" style="color:dodgerblue;"></i>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-1">Address</h5>
                      <address>{{ garageData.address }}</address>
                    </div>
                  </div>

                  <!-- Ratings -->
                  <div class="d-flex flex-row mb-3">
                    <div>
                      <img src="./assets/img/googleicon.png" alt="Google" style="width:28px; height:28px !important; margin-right:16px;">
                    </div>
                    <div>
                      <h5 class="mb-1">Ratings / Reviews</h5>
                      <div class="div_ratings">
                        <span>{{ garageData.googleRatings }}</span>
                        <div class="div_new_rating">
                          <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                            <mat-icon *ngIf="star === 'full'">star</mat-icon>
                            <mat-icon *ngIf="star === 'half'">star_half</mat-icon>
                          </ng-container>
                        </div>
                        
                      </div>
                      <p>from {{ garageData.googleReviewNumbers }} Google reviews</p>
                    </div>
                  </div>

                   <div class="d-flex flex-row mb-3">
                    <div>
                      <div class="icon text-primary fs-28 me-4 mt-n1"> 
                        <!-- <i></i> -->
                        <div style="font-size: 20px;">🕘</div>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-1">Working Hours</h5>
                      <div>Mon-Sat : {{ garageData?.workingHours }}</div>
                       Sunday : Closed
                    </div>
                  </div>
                  <!-- <div class="button_div">
                    <button class="requestBtn" (click)="openRequestModal()">
                      Request a Call Back
                    </button>
                  </div> -->


                  <!-- ==========requesta-a-call-bac-pop-up======= -->
                  <!-- <div class="modal fade popup" id="requestCallBackModal" tabindex="-1" aria-labelledby="requestCallBackModalLabel" aria-hidden="true" style="    background: rgba(0, 0, 0, 0.8) !important;">
                      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 35%; top: 60px;">
                          <div class="modal-content" style="border-radius: 16px;">

                          <div class="d-flex justify-content-between align-items-center mb-3" style=" padding: 10px 20px; margin: 0 !important; background: linear-gradient(to right, #F7FBFF, #FFFFFF);     border-radius: 10px;">
                              <h3 class="fw-bold m-0" style="font-size: 20px; font-weight: 900 !important; color: #0B2636;">
                              <div class="call-icon-and-text">
                                  <img src="./assets/img/call-image.png">
                                  <div> Request a Call Back </div>
                                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              
                              </h3>
                              
                          </div>

                          <p class="text-muted mb-4" style=" font-size: 14px !important;color: #57738A !important; padding: 5px 20px; margin: 0 !important; font-weight: 400;">Leave your details and (optionally) pick a coupon.</p>

                          <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" style="padding: 10px 20px;">
                          <input type="text" formControlName="name" class="form-control mb-2 p-2" placeholder="Name*" required>
                          <div class="text-danger small"
                              *ngIf="callbackForm.get('name')?.touched &&
                                      callbackForm.get('name')?.hasError('required')">
                            Name is required
                          </div>
                          <input type="text" formControlName="mobile" class="form-control mb-2 p-2" placeholder="Mobile Number*" maxlength="10" required>
                          <div class="text-danger small"
                                *ngIf="callbackForm.get('mobile')?.touched">
                              <span *ngIf="callbackForm.get('mobile')?.hasError('required')">
                                Mobile number is required
                              </span>
                              <span *ngIf="callbackForm.get('mobile')?.hasError('pattern')">
                                Enter a valid 10-digit mobile number
                              </span>
                          </div>
                          <input type="text" formControlName="issue" class="form-control mb-2 p-2" placeholder="Describe Your Issue (Optional)">

                          <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
                              <div *ngFor="let c of coupons" 
                                  class="coupon-card-option"
                                  [class.active]="selectedCoupon?.couponId === c.couponId"
                                  (click)="applyCoupon(c)">
                              <h5 class="fw-bold mb-1">{{ c.couponCode }} - {{ c.discount }}%</h5>
                              <p class="small m-0 text-muted">{{ c.description }}</p>
                              </div>
                          </div>

                          <button type="submit" class="btn btn-primary w-100" style= "background:#144579;">Submit Details</button>
                          
                          </form>
                          </div>
                      </div>
                  </div> -->


                  <!-- Overlay -->
                  <div     class="popup-overlay"   [class.active]="isModalOpen"     (click)="closeModal()">  </div>
                  
                  <!-- <div class="popup-container" [class.active]="isModalOpen">
                    <div class="popup-content">

             
                      <div class="popup-header">
                        <h3 class="fw-bold m-0">
                          <div class="call-icon-and-text">
                            <img src="./assets/img/call-image.png">
                            <div> Request a Call Back </div>
                            <button type="button" class="btn-close" (click)="closeModal()"></button>
                          </div>
                        </h3>
                      </div>

                      <p class="text-muted mb-4">
                        Leave your details and (optionally) pick a coupon.
                      </p>

                      <form [formGroup]="callbackForm" (ngSubmit)="submitForm()">
                        <input type="text" formControlName="name" class="form-control mb-2 p-2" placeholder="Name*" required>
                        <div class="text-danger small"
                          *ngIf="callbackForm.get('name')?.touched && callbackForm.get('name')?.hasError('required')">
                          Name is required
                        </div>

                        <input type="text" formControlName="mobile" class="form-control mb-2 p-2" placeholder="Mobile Number*" maxlength="10" required>
                        <div class="text-danger small" *ngIf="callbackForm.get('mobile')?.touched">
                          <span *ngIf="callbackForm.get('mobile')?.hasError('required')">Mobile number is required</span>
                          <span *ngIf="callbackForm.get('mobile')?.hasError('pattern')">Enter a valid 10-digit mobile number</span>
                        </div>

                        <input type="text" formControlName="issue" class="form-control mb-2 p-2" placeholder="Describe Your Issue (Optional)">

                        <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
                          <div *ngFor="let c of coupons" 
                              class="coupon-card-option"
                              [class.active]="selectedCoupon?.couponId === c.couponId"
                              (click)="applyCoupon(c)">
                            <h5 class="fw-bold mb-1">{{ c.couponCode }} - {{ c.discount }}%</h5>
                            <p class="small m-0 text-muted">{{ c.description }}</p>
                          </div>
                        </div>

                        <button type="submit" class="btn btn-primary w-100" style="background:#144579;">Submit Details</button>
                      </form>
                    </div>
                  </div> -->

                 <div class="popup-container" [class.active]="isModalOpen">
                  <div class="popup-content">

                    <!-- Header -->
                    <div class="popup-header">
                      <h3 class="fw-bold m-0">
                        <div class="call-icon-and-text d-flex align-items-center gap-2">
                          <!-- Updated icon -->
                          <!-- <img src="./assets/img/appointment-icon.png" alt="appointment" /> -->
                          <mat-icon>bookmark_border</mat-icon>
                          <!-- Updated title -->
                          <div>Book an Appointment</div>

                          <button type="button" class="btn-close ms-auto" (click)="closeModal()"></button>
                        </div>
                      </h3>
                    </div>

                    <!-- Updated subheading -->
                    <p class="text-muted mb-4">
                      Quick and easy appointment booking.
                    </p>
                    <!-- Form -->
                   <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" class="callback-form">
                    <div class="form-scroll-area">
                      <!-- Name -->
                      <div class="form-floating mb-3">
                        <input type="text"
                              formControlName="name"
                              class="form-control"
                              id="custName"
                              placeholder="Name">
                        <label for="custName">Name *</label>
                      </div>
                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('name')?.invalid">
                        Name is required
                      </div>
                      <!-- Mobile -->
                      <div class="form-floating mb-3">
                        <input type="text"
                              formControlName="mobile"
                              class="form-control"
                              id="custMobile"
                              placeholder="Mobile Number"
                              maxlength="10">
                        <label for="custMobile">Mobile Number *</label>
                      </div>
                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('mobile')?.invalid">
                        <span *ngIf="callbackForm.get('mobile')?.errors?.['required']">
                          Mobile number is required
                        </span>
                        <span *ngIf="callbackForm.get('mobile')?.errors?.['pattern']">
                          Mobile number must be 10 digits
                        </span>
                      </div>

                      <!-- Registration Number -->
                       <div class="form-floating mb-3">
                        <input type="text" formControlName="registrationNumber" (input)="formatRegistrationNumber()" class="form-control" id="regNo" placeholder="KA 03 MX 5059">
                        <label for="regNo">Registration Number *</label>
                        </div>
                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('registrationNumber')?.invalid">
                        <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['required']">
                          Registration number is required
                        </span>
                        <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['pattern']">
                          Format must be like KA03AB1234
                        </span>
                      </div>

                      <!-- Issue Dropdown -->
                     <div class="form-floating mb-3 select-floating">
                      <select
                        formControlName="issue"
                        class="form-select"
                        id="issueSelect"
                        required
                      >
                        <option value="" disabled ></option>
                        <option *ngFor="let service of services" [ngValue]="service">
                          {{ service.label }}
                        </option>
                      </select>

                      <label for="issueSelect">Select the issue *</label>
                      <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
                    </div>



                      <div class="text-danger small mb-2" *ngIf="submitted && callbackForm.get('issue')?.invalid">
                        Please select an issue
                      </div>
                    </div>
                    <!-- Submit Button -->
                    <div class="form-footer">
                      <button type="submit" class="btn btn-primary w-100" [disabled]="isSubmitting">
                        {{ isSubmitting ? 'Booking...' : 'Book an Appointment' }}
                      </button>
                    </div>
                  </form>
                  </div>
                </div>               
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<section class="wrapper gradient-8 bg-lines" id="contact-us">
  <div class="container py-15 py-md-17 text-center">
    <div class="row">
      <div class="col-lg-10 col-xl-9 col-xxl-8 mx-auto text-center">
        <h2 class="fs-16 text-uppercase text-white mb-3">TRUSTED BY CAR OWNERS</h2>
        <h3 class="display-3 text-white mb-6">We are
        <span class="underline-2 underline-gradient-6"><em>trusted</em></span> by over 5,000+ car owners.Book your appointment with confidence.</h3>
        <!-- <a href="#" class="btn btn-white">Join Us</a> -->
        <div class="button_div">
          <button class="requestBtn-new" (click)="openRequestModal()">
            Book an Appointment
          </button>
        </div>
      </div>
      <!-- /column -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</section>
<!-- /section -->

<footer class="bg-dark text-inverse">
  <div class="container py-10">
    <div class="row gy-6 gy-lg-0">
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <div  class="bottom-logo-txt">
            <!-- <img style="align-items: center;  display: flex; justify-content: center;  width: 24px;" class="mb-4 imp" src="../../../assets/img/mobile_autoverse_logo.svg" srcset="./assets/img/mobile_autoverse_logo.svg 2x" alt="" />
            <div class="bottom-logo-txt-main" >AUTOVERSE</div> -->
            <img
                [src]="garageData?.primaryLogo"
                alt="Garage Logo"
                class="navbar-garage-logo"
        />
          </div>
          <p class="mb-4 p" style="font-size: 16px">© 2023 Autoverse.  <br class="d-none d-lg-block" />All rights reserved.</p>
          <!-- <nav class="nav social social-white">
            <a href="#"><i class="uil uil-twitter"></i></a>
            <a href="#"><i class="uil uil-facebook-f"></i></a>
            <a href="#"><i class="uil uil-dribbble"></i></a>
            <a href="#"><i class="uil uil-instagram"></i></a>
            <a href="#"><i class="uil uil-youtube"></i></a>
          </nav> -->
          <!-- /.social -->
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3">Get in Touch</h4>
          <address class="pe-xl-15 pe-xxl-17 address">{{ garageData?.address }}</address>
          <a href="mailto:#">{{ garageData.email }}</a><br />
          <div style="color: #aaa !important;    font-weight: 500;">{{ garageData.mobileNumber }}</div>
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3 footre-learnmore">Learn More</h4>
          <ul class="list-unstyled  mb-0">
            <li><a href="#">Book Service Appointment</a></li>
            <li><a class="nav-link" (click)="scrollTo('About-us')">About Us</a></li>
            <li><a class="nav-link" (click)="scrollTo('our-services')">Our Services</a></li>
            <li><a class="nav-link" (click)="scrollTo('customer-review')">Customer Reviews</a></li>
            <li><a class="nav-link" (click)="scrollTo('contact-us')">Contact Us</a></li>
          </ul>
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-12 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3">Service With Care</h4>
          <p class="mb-5">A friendly garage that understands your car and your concerns.</p>
          <div class="newsletter-wrapper">
            <!-- Begin Mailchimp Signup Form -->
            <div id="mc_embed_signup2">
              <form action="https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&amp;id=b49ef47a9a" method="post" id="mc-embedded-subscribe-form2" name="mc-embedded-subscribe-form" class="validate dark-fields" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll2">
                  <div class="mc-field-group input-group form-floating">
                    <!-- <input type="email" value="" name="EMAIL" class="required email form-control" placeholder="Email Address" id="mce-EMAIL2">
                    <label for="mce-EMAIL2">Email Address</label>
                    <input type="submit" value="Join" name="subscribe" id="mc-embedded-subscribe2" class="btn btn-primary"> -->
                    <div class="button_div">
                      <button class="requestBtn-new" (click)="openRequestModal()">
                        Book an Appointment
                      </button>
                    </div>
                  </div>
                  <div id="mce-responses2" class="clear">
                    <div class="response" id="mce-error-response2" style="display:none"></div>
                    <div class="response" id="mce-success-response2" style="display:none"></div>
                  </div> <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_ddc180777a163e0f9f66ee014_4b1bcfa0bc" tabindex="-1" value=""></div>
                  <div class="clear"></div>
                </div>
              </form>
            </div>
            <!--End mc_embed_signup-->
          </div>
          <!-- /.newsletter-wrapper -->
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
    </div>
    <!--/.row -->
  </div>
  <!-- /.container -->
</footer>
<!-- ---------------------------INSURANCE BLOCK--------------------------- -->
<!-- <section class="wrapper bg-light wrapper-border"*ngIf="garageData?.insuranceUrls?.length > 0"id="insurance-section" style = "border:none" >
  <div class="container pt-md-10 pb-md-10">
    <p class="text-center mb-8">Trusted Cashless Partners for Top Insurers</p>

    <div class="ticker-wrapper">
      <div class="ticker">
        <div class="ticker-item" *ngFor="let url of garageData.insuranceUrls">
          <img [src]="url" alt="Insurance Partner" />
        </div>
        <div class="ticker-item" *ngFor="let url of garageData.insuranceUrls">
          <img [src]="url" alt="Insurance Partner" />
        </div>
      </div>
    </div>
  </div>
</section> -->

 <!-- ------------------------------TESTIMONIALS BLOCK-------------------- -->
<!-- <section class="wrapper bg-light" id="reviews-section">
  <div class="container pt-md-16">
    <h2 class="display-4 mb-3 text-center">Happy Customers</h2>
    <p class="lead text-center mb-6 px-md-16 px-lg-0">
      Customer satisfaction is our major goal. See what our customers are saying about us.
    </p>

    <div class="position-relative d-flex align-items-center">
        <button class="btn-arrow-prev"
              (click)="scrollLeft()"
              [disabled]="isPrevDisabled">
        &#8592;
      </button>

      <div class="reviews-wrapper">
        <div class="review-card" *ngFor="let review of garageData?.reviews">
          <p class="testimonial">{{ review.testimonial }}</p>
          <h5 class="reviewer-name">{{ review.name }}</h5>
          <div class="stars">
            <ng-container *ngFor="let star of getStars(review.rating)">
              <i *ngIf="star === 'full'" class="bi bi-star-fill"></i>
              <i *ngIf="star === 'half'" class="bi bi-star-half"></i>
              <i *ngIf="star === 'empty'" class="bi bi-star"></i>
            </ng-container>
          </div>
        </div>
      </div>

       <button class="btn-arrow-next"
              (click)="scrollRight()"
              [disabled]="isNextDisabled">
        &#8594;
      </button>
    </div>
  </div>
</section> -->

<!-- /section -->

<!-- ----------------------------TEAM BLOCK--------------------- -->
<!-- <section class="wrapper bg-light" id="employee-section" style="display: none;">
  <div class="container ">
      <div class="row gx-lg-8 gx-xl-12 gy-10 align-items-center">
          <div class="col-lg-4">
              <h2 class="fs-15 text-uppercase text-line text-primary text-center mb-3">Meet the Team</h2>
              <h3 class="display-5 mb-5">Save your time and money by choosing our expert team.</h3>
              <p>Get reliable repairs and top-notch service from skilled professionals you can trust. Experience quality and efficiency that keeps your car running smoothly.</p>
              <button id="see-all-btn" class="btn btn-primary rounded-pill mt-3">See All Members</button>
          </div>
          <div class="col-lg-8">
              <div id="showthreeimage" class="text-center mb-6">
                  <div class="row">
                  </div>
              </div>

              <div id="showallimage" class="text-center mb-6" style="display: none;">
                  <div class="row">
                  </div>
              </div>
          </div>
      </div>
  </div>
</section> -->


<!-- -----------------------------------------GALLERY BLOCK----------------- -->
<!-- <section class="wrapper bg-light" id="service-section"  *ngIf="garageData?.serviceImages?.length > 0" >
  <div class="container pt-14 pt-md-16">
    <div class="row">
      <div class="col-lg-9 col-xl-8 col-xxl-7 mx-auto text-center">
        <h2 class="fs-15 text-uppercase text-muted mb-3">OUR WORK</h2>
        <h3 class="display-4 mb-10">Take a look at the repairs and services we've done for various cars.</h3>
      </div>
    </div>
  </div>
  <div class="container-fluid px-md-6">
    <div class="swiper-container blog grid-view mb-17 mb-md-19" data-margin="30" data-nav="true" data-dots="true" data-items-xxl="3" data-items-md="2" data-items-xs="1">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" id="service-images" style="display: flex;">
          </div>
          
        </div>
      </div>
    </div>
  </div>
</section> -->
<!-- <footer class="bg-light text-dark mt-0">
  <div class="blue-box text-white py-4 mb-4">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-8 text-md-start text-center mb-3 mb-md-0">
          <h2 class="getIn">
            Get in touch! <br>
            Leave your details for a callback and we'll contact you shortly
          </h2>
        </div>
        <div class="col-md-4 text-md-end text-center">
          <button class="btn btn-white" data-bs-toggle="modal" data-bs-target="#requestCallBackModal">
            Request a Call Back
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="container py-4">
    <div class="row text-center">
      <div class="col-md-4">
        <h5 class="mb-3">Address</h5>
        <p>
          {{ garageData?.address }}<br>
        </p>
      </div>
      <div class="col-md-4">
        <h5 class="mb-3">Working Hours</h5>
        <p>
          Mon-Sat : {{ garageData?.workingHours }} <br>
          Sunday : Closed
        </p>
      </div>
      <div class="col-md-4">
        <h5 class="mb-3">E-mail</h5>
        <p>
          <a *ngIf="garageData?.email" href="mailto:{{ garageData.email }}">{{ garageData.email }}</a>
        </p>
      </div>
    </div>
    <div class="text-center mt-3">
      <p>© 2023 Autoverse. All rights reserved.</p>
    </div>
  </div>
</footer> -->

<div class="page-loader" *ngIf="isPageLoading">
  <div class="spinner"></div>
</div>
